import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class TourService {
  constructor(private http: HttpClient, private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('tour/search', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('tour/list', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('tour/all', val_params);
  }

  get(val_id: number) {
    return this.restService.get('tour/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('tour/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('tour/update', val_id, data);
  }

  updateSave(data: any) {
    return this.restService.save('tour/update/save', data);
  }

  updateVideo(val_id: number, data: any) {
    return this.restService.update('tour/update/video', val_id, data);
  }

  saveImage(data: any) {
    return this.restService.save('tour/save/image', data);
  }

  delete(val_id: number) {
    return this.restService.delete('tour/delete', val_id);
  }
  
}

